<template>
  <div class="unknown-type-definition">
    <PropertyDefinition :name="name" :type-display="'Unknown'">
      <template #icon><CubeIcon /></template>
    </PropertyDefinition>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import PropertyDefinition from "@/components/graph/definition/PropertyDefinition.vue";
import CubeIcon from "@/components/icons/CubeIcon.vue";

export default defineComponent({
  name: "UnknownDefinition",
  components: { CubeIcon, PropertyDefinition },
  props: {
    name: {
      type: String,
      required: false,
    },
  },
});
</script>
